export default (function (object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-convert/esm/util/styleObjectFunction.js
// module id = 1797
// module chunks = 0